import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper";
import Table from "@/common/components/Table";
import TextField from "@/common/components/TextField";
import useDebounce from "@/common/hooks/useDebounce";
import { useFilterParams } from "@/common/hooks/useFilterParams";
import { scrapRulesDefaultColumns } from "../../constants/scrapRuleDefaultColumns.constant";
import { useScrapRules } from "@/common/hooks/queries/useScrapRules";
import { BookX, SearchIcon } from "lucide-react";
import { ScrapRulesTransformer } from "../../services/scrapRulesTransformer";
import ListHeader from "@/common/components/ListHeader";

const ScrapRulesList = () => {
  const { filterParams, setFilterParams } = useFilterParams();

  const [search, setSearch] = useDebounce(filterParams.search);

  const {
    meta,
    data: scrapRules,
    isPending: scrapRulesIsPending,
    error: scrapRulesError = {} as any,
    refetch: refetchScrapRules,
  } = useScrapRules({
    filters: {
      search: search,
      page: Number(filterParams.page) || 1,
    },
    mapper: ScrapRulesTransformer.tableTransformer(),
  });

  return (
    <ErrorMessageWrapper
      className="h-[calc(100vh-192px)]"
      statusCode={scrapRulesError?.status}
      refetchFunction={refetchScrapRules}
    >
      <div className="flex flex-col gap-6">
        <ListHeader
          Icon={<BookX className="w-10 h-10" strokeWidth={1.5} />}
          title="Regras de desfazimento"
          createButtonText="Nova regra"
          operationKlassToCheckPermission="Client::Maintenance::ScrapRules::Create"
          disableCreateButton={scrapRulesIsPending || scrapRulesError?.status === 403}
        />
        <div className="flex flex-col gap-4">
          <TextField
            LeftIcon={<SearchIcon />}
            placeholder="Pesquisar"
            className="rounded-sm shadow-[4px_0px_16px_0px_rgba(0,_0,_0,_0.5)]"
            onChange={(e) => {
              setSearch((e.target as HTMLInputElement).value);
              setFilterParams((prev) => ({ ...prev, search: (e.target as HTMLInputElement).value, page: 1 }));
            }}
            value={filterParams.search}
          />
        </div>

        <Table
          className="max-h-[calc(100vh-324px)]"
          columns={scrapRulesDefaultColumns}
          isLoadingData={scrapRulesIsPending}
          page={filterParams.page || 1}
          rows={scrapRules}
          totalPages={meta.total_pages}
          totalCount={meta.total}
          hasPagination
          setPage={(page) => setFilterParams((prev) => ({ ...prev, page }))}
        />
      </div>
    </ErrorMessageWrapper>
  );
}

export default ScrapRulesList;
